export const dashboardSections = {
    loyaltyConfig: 'loyaltyConfig',
    loyaltySubmitAReceipt: 'loyaltySubmitAReceipt',
    pointsHistory: 'pointsHistory',
    earnPoints: 'earnPoints',
    benefits: 'benefits',
    rewards: 'rewards',
    faq: 'faq',
    birthday: 'birthday',
    ctaSection: 'ctaSection'
};
